// src/components/ChatTour.js - Fixed positions and localStorage key
import React, { useState } from 'react';
import './ChatTour.css';

const ChatTour = ({ isOpen, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);
  
  if (!isOpen) return null;
  
  const steps = [
    {
      title: "User Prompt Area",
      content: "Type your message here to chat with Claude. Press Enter to send or Shift+Enter for a new line.",
      position: { top: '70%', left: '50%' }
    },
    {
      title: "Conversation History",
      content: "This area shows your ongoing conversation with Claude. Scroll up to see previous messages.",
      position: { top: '40%', left: '50%' }
    },
    {
      title: "Search Box",
      content: "Search through your chat history and topics to find specific information.",
      position: { top: '85%', left: '20%' }
    },
    {
      title: "Conversation Summary",
      content: "Get a quick summary of your current conversation to review key points.",
      position: { top: '15%', left: '85%' } // FIXED: Moved to upper right
    },
    {
      title: "Prompt Enhancer",
      content: "Click this magic wand to get AI suggestions for improving your prompt quality.",
      position: { top: '85%', left: '80%' }
    },
    {
      title: "Prompt Library",
      content: "Access your saved prompts for quick reuse. Save effective prompts to use them again later.",
      position: { top: '85%', left: '85%' }
    },
    {
      title: "Start New Topics",
      content: "Click here to start a fresh conversation with Claude on a new topic.",
      position: { top: '10%', left: '30%' } // FIXED: Adjusted to avoid truncation
    }
  ];
  
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleClose(true);
    }
  };
  
  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  
  const handleClose = (completed = false) => {
    // Mark tour as shown if completed
    if (completed) {
      localStorage.setItem('blue_comet_tour_shown', 'true'); // FIXED: Consistent key name
    }
    
    // Reset current step
    setCurrentStep(0);
    
    // Call the onClose callback
    if (onClose) onClose(completed);
  };
  
  const { title, content, position } = steps[currentStep];
  
  return (
    <div className="chat-tour-overlay">
      <div className="chat-tour-backdrop" style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}></div>
      
      <div 
        className="chat-tour-tooltip"
        style={{
          top: position.top,
          left: position.left,
          transform: 'translate(-50%, -50%)'
        }}
      >
        {title && <div className="chat-tour-tooltip-title">{title}</div>}
        <div className="chat-tour-tooltip-content">{content}</div>
        
        <div className="chat-tour-tooltip-footer">
          <div className="chat-tour-step-counter">
            {currentStep + 1} / {steps.length}
          </div>
          <div className="chat-tour-buttons">
            {currentStep > 0 && (
              <button className="chat-tour-button chat-tour-prev-button" onClick={handlePrev}>
                Previous
              </button>
            )}
            {currentStep < steps.length - 1 ? (
              <button className="chat-tour-button chat-tour-next-button" onClick={handleNext}>
                Next
              </button>
            ) : (
              <button className="chat-tour-button chat-tour-finish-button" onClick={() => handleClose(true)}>
                Finish
              </button>
            )}
          </div>
        </div>
        <button className="chat-tour-close-button" onClick={() => handleClose()}>×</button>
      </div>
    </div>
  );
};

export default ChatTour;